import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    franchiseProduct: null,
    franchiseProducts: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const franchiseProductReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.FRANCHISEPRODUCT_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.FRANCHISEPRODUCT_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.FRANCHISEPRODUCT_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        case actionTypes.FRANCHISEPRODUCT_RESET: {
            return updateState(state, { ...action.data, lastState: constants.STATE_RESET, lastScope: 'reset' });
        }
        default: {
            return state;
        }
    }
};

export default franchiseProductReducer;
